import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'core-js/features/array/from'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import './assets/scss/index.scss'
import './plugins/axiosSettings'
import App from './App.vue'
import PageHeader from './components/molecules/PageHeader.vue'
import IconLink from './components/molecules/IconLink.vue'
import IconErrorMessage from './components/molecules/IconErrorMessage.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false
Vue.component('page-header', PageHeader)
Vue.component('icon-link', IconLink)
Vue.component('icon-error', IconErrorMessage)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
